module.exports = __webpack_public_path__ + "media/images/avatar/8-d2c64822b6b25907fbbcddd597e94193.svg";